import { NavigateParams, RouteInstance, RouteParams } from 'atomic-router';
import { navigate } from './navigate';

export const replace = <TRouteParams extends RouteParams = RouteParams>(
	route: RouteInstance<TRouteParams>,
	params?: Omit<Partial<NavigateParams<TRouteParams>>, 'replace'>,
) => navigate(route, { ...params, replace: true });
